import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        orders: [],
        repositoryName: 'orders',
        filters: {
            search: null,
            statusId: null,
            date: [],
        },
    },
    mutations: {
        ...mixinMutations(),
    },
    getters: {
        ...mixinGetters(),
    },
    actions: {
        ...mixinActions('order'),

        placeOrder(context, params) {
            return axios
                .post('/api/order/create', {
                    ...params,
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },
    },
};
